module.exports = __webpack_public_path__ + "img/housing.bb56c28b.png";